(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experts-videos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function lockPageScroll(){
    document.documentElement.style.overflow = 'hidden';
  }

  function syncPageScrollLock(){
    if(!document.querySelector('.tev__modal:not([hidden])')){
      document.documentElement.style.overflow = '';
    }
  }

  function init(root){
    if(!root || root.__tevInit) return; root.__tevInit = true;
    var videos = root.querySelectorAll('.tev__video');
    var quotes = root.querySelectorAll('.tev__quote');
    var thumbs = root.querySelectorAll('.tev__thumb');
    var cards  = root.querySelectorAll('.tev__cardv');
    var modal  = root.querySelector('.tev__modal');
    var mbody  = modal ? modal.querySelector('.tev__modal-body') : null;
    var thumbsEl = root.querySelector('.tev__thumbs');
    var navEl    = root.querySelector('.tev__thumbs-nav');
    var prevBtn  = root.querySelector('.tev__thumbs-prev');
    var nextBtn  = root.querySelector('.tev__thumbs-next');
    var opener = null; // bouton ayant ouvert la modale (pour rendre le focus)
    var isEditorial = root.classList.contains('tev--layout-editorial');
    var isSpotlight = root.classList.contains('tev--layout-spotlight');
    var countEl = root.querySelector('.tev__count');
    var current = 0; // index de la vidéo en vedette (compteur + flèches editorial)
    function pad(n){ return (n < 10 ? '0' : '') + n; }

    function setActive(i){
      videos.forEach(function(v){
        var m = v.querySelector('.tev__media');
        if(m){ try{ m.pause(); }catch(e){} m.removeAttribute('controls'); }
        v.classList.remove('is-active','is-playing');
      });
      quotes.forEach(function(q){ q.classList.remove('is-active'); });
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      if(videos[i]) videos[i].classList.add('is-active');
      if(thumbs[i]){
        thumbs[i].classList.add('is-active');
        if(thumbs[i].scrollIntoView){ try{ thumbs[i].scrollIntoView({inline:'nearest', block:'nearest'}); }catch(e){} }
      }
      cards.forEach(function(c, idx){
        var on = idx === i;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if(on && c.scrollIntoView){ try{ c.scrollIntoView({inline:'nearest', block:'nearest'}); }catch(e){} }
      });
      // Cards : une carte sans citation ne doit pas vider le texte déjà affiché
      if(cards.length){
        var q = quotes[i];
        if(q && q.querySelector('.tev__quote-text')){
          q.classList.add('is-active');
        }else{
          var keep = null;
          quotes.forEach(function(x){
            if(!keep && x.querySelector('.tev__quote-text')) keep = x;
          });
          if(keep) keep.classList.add('is-active');
        }
      }else if(quotes[i]){
        quotes[i].classList.add('is-active');
      }
      current = i;
      if(countEl && videos.length){ countEl.textContent = pad(i + 1) + ' / ' + pad(videos.length); }
      updateThumbsNav();
    }
    root.__tevSetActive = setActive;

    // Navigation des vignettes (prev/next) : visible seulement en cas de débordement,
    // chaque flèche grisée quand on est en bout de course.
    function updateThumbsNav(){
      if(!navEl) return;
      // Spotlight : compteur seul. Editorial : compteur + flèches prev/next (navigation
      // entre vidéos, pas défilement des vignettes) grisées en bout de course.
      if(isSpotlight || isEditorial){
        navEl.classList.toggle('is-visible', thumbs.length > 1);
        if(isEditorial){
          if(prevBtn){ prevBtn.disabled = current <= 0; }
          if(nextBtn){ nextBtn.disabled = current >= thumbs.length - 1; }
        }
        return;
      }
      if(!thumbsEl) return;
      var max = thumbsEl.scrollWidth - thumbsEl.clientWidth;
      navEl.classList.toggle('is-visible', max > 4);
      if(prevBtn){ prevBtn.disabled = thumbsEl.scrollLeft <= 4; }
      if(nextBtn){ nextBtn.disabled = thumbsEl.scrollLeft >= (max - 4); }
    }
    function stepThumbs(dir){
      if(isEditorial){
        var n = Math.max(0, Math.min(thumbs.length - 1, current + dir));
        if(n !== current){ setActive(n); }
        return;
      }
      if(!thumbsEl) return;
      thumbsEl.scrollBy({ left: dir * Math.max(thumbsEl.clientWidth * 0.8, 120), behavior:'smooth' });
    }
    root.__tevUpdateThumbsNav = updateThumbsNav;
    if(thumbsEl){ thumbsEl.addEventListener('scroll', updateThumbsNav, { passive:true }); }
    if(prevBtn){ prevBtn.addEventListener('click', function(){ stepThumbs(-1); }); }
    if(nextBtn){ nextBtn.addEventListener('click', function(){ stepThumbs(1); }); }
    updateThumbsNav();

    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ setActive(parseInt(t.dataset.index,10)); });
    });

    root.querySelectorAll('.tev__play').forEach(function(btn){
      btn.addEventListener('click', function(){
        var wrap = btn.closest('.tev__video');
        var m = wrap.querySelector('.tev__media');
        if(!m) return;
        wrap.classList.add('is-playing');
        m.setAttribute('controls','');
        try{ m.play(); }catch(e){}
      });
    });

    function closeModal(){
      if(!modal || modal.hidden) return;
      var v = mbody.querySelector('video'); if(v){ try{ v.pause(); }catch(e){} }
      modal.hidden = true; mbody.innerHTML = '';
      syncPageScrollLock();
      if(window.theme && theme.a11y && theme.a11y.removeTrapFocus){ theme.a11y.removeTrapFocus(opener); }
      else if(opener){ try{ opener.focus(); }catch(e){} }
      opener = null;
    }
    root.__tevCloseModal = closeModal;

    // Ouverture de la modale depuis un conteneur de vidéo (.tev__video ou .tev__cardv)
    function openFromWrap(wrap, btn){
      if(!modal || !wrap) return;
      var m = wrap.querySelector('.tev__media');
      if(!m){ return; }                       // pas de vidéo -> rien à agrandir
      try{ m.pause(); }catch(e){}              // évite le double-audio derrière la modale
      var arRaw = getComputedStyle(wrap).getPropertyValue('--ar').trim();
      mbody.innerHTML = '';
      var frame = document.createElement('div');   // cadre dimensionné par CSS -> pas de saut petit/grand
      frame.className = 'tev__modal-frame';
      frame.style.setProperty('--ar', arRaw === '' ? '0.5625' : arRaw);
      var c = m.cloneNode(true);
      c.classList.remove('tev__media');       // sinon le clone reste en absolute -> 0×0 dans la modale
      c.setAttribute('controls',''); c.removeAttribute('muted'); c.muted = false;
      try{ c.currentTime = m.currentTime; }catch(e){}  // reprend au même endroit
      frame.appendChild(c);
      mbody.appendChild(frame);
      try{ c.play(); }catch(e){}
      opener = btn;
      modal.hidden = false;
      lockPageScroll();
      var closeBtn = modal.querySelector('.tev__close');
      if(window.theme && theme.a11y && theme.a11y.trapFocus){ theme.a11y.trapFocus(modal, closeBtn); }
      else if(closeBtn){ try{ closeBtn.focus(); }catch(e){} }
    }

    root.querySelectorAll('.tev__expand').forEach(function(btn){
      btn.addEventListener('click', function(){ openFromWrap(btn.closest('.tev__video'), btn); });
    });

    // Variante "cards" : 1er clic = sélection (citation + liseré), reclic = modale
    cards.forEach(function(card){
      card.addEventListener('click', function(){
        var already = card.classList.contains('is-active');
        setActive(parseInt(card.dataset.index, 10));
        if(already) openFromWrap(card, card);
      });
    });

    if(modal){
      modal.addEventListener('click', function(e){
        if(e.target === modal || e.target.closest('.tev__close')) closeModal();
      });
    }
  }

  function boot(){ document.querySelectorAll('.tev').forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector ? e.target.querySelector('.tev') : null; if(r) init(r);
  });

  // Handlers globaux enregistrés UNE SEULE FOIS (pas par section -> aucune fuite en édition)
  if(!window.__tevGlobalBound){
    window.__tevGlobalBound = true;
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        document.querySelectorAll('.tev').forEach(function(root){
          if(root.__tevCloseModal) root.__tevCloseModal();
        });
      }
    });
    // Confort éditeur de thème : sélection d'un block -> on met sa vidéo en vedette.
    // On active TOUTES les racines concernées (vignette, carte ou vidéo — cette
    // dernière couvre le cas "vidéo unique" où les vignettes ne sont pas rendues) :
    // avec une disposition mobile différente, le même block existe dans deux rendus.
    document.addEventListener('shopify:block:select', function(e){
      var id = e.detail && e.detail.blockId; if(!id) return;
      document.querySelectorAll('.tev__thumb[data-block-id="' + id + '"], .tev__cardv[data-block-id="' + id + '"], .tev__video[data-block-id="' + id + '"]').forEach(function(el){
        var root = el.closest('.tev');
        if(root && root.__tevSetActive){ root.__tevSetActive(parseInt(el.dataset.index, 10)); }
      });
    });
    window.addEventListener('resize', function(){
      document.querySelectorAll('.tev').forEach(function(r){ if(r.__tevUpdateThumbsNav){ r.__tevUpdateThumbsNav(); } });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
